import { RadioGroup } from '../components/RadioGroup';
import { RadioButton } from '../components/RadioButton';
import { useDispatch, useSelector } from "react-redux";
import { createReturnParameterSelector, setReturnParameter } from "../store";

export const GrufReverbDecay = ({returnName}) => {
    const parameterName = "decay";
    const parameterValue = useSelector(createReturnParameterSelector(returnName, parameterName));
    const dispatch = useDispatch();
    return (
        <div className="gruf-reverb-time">
            <RadioGroup>
            <div>Curta</div><RadioButton // todo: curta, etc. són labels!
                style={{width: "20%"}}
                checked={parameterValue == 1.0} 
                onNewValue={(value) => value && dispatch(setReturnParameter({returnName, parameter: parameterName, value: '1.0'}))}
            ></RadioButton>
            <div>Mitja</div><RadioButton
                style={{width: "50%"}}
                checked={parameterValue == 5.0} 
                onNewValue={(value) => value && dispatch(setReturnParameter({returnName, parameter: parameterName, value: '5.0'}))}
            ></RadioButton>
            <div>Llarga</div><RadioButton
                style={{width: "100%"}}
                checked={parameterValue == 12.0} 
                onNewValue={(value) => value && dispatch(setReturnParameter({returnName, parameter: parameterName, value: '12.0'}))}
            ></RadioButton>
            </RadioGroup>
        </div>
    )
}